import styled from "styled-components";

export const StyledCertifications = styled.div`
  height: 100%;

  & .empty-content {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .certifications-header {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: start;
  }

  & .filters-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
    flex-wrap: wrap;
  }

  & .search-container {
    width: 250px;
  }

  & .certifications-content {
    margin-top: 30px;
  }

  & .loader {
    padding-top: 25%;
  }

  & .grid-cols-2 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;
